export default "__VITE_ASSET__$uf5OW2s__"